module.exports = __webpack_public_path__ + "static/home-01-5d9158986b8c6eebae0cdf78c2777527.jpg";